import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { ShapeStarIcon } from '@/src/components/icon/stroke/ShapeStarIcon';
import { ShapeStarFilledIcon } from '@/src/components/icon/filled/ShapeStarFilledIcon';
import { getFocusRingBoxShadow } from '@/src/components/focusring/focusring';

export const flowRating: Components<Theme>['MuiRating'] = {
  defaultProps: {
    size: 'medium',
    precision: 1,
    max: 5,
    icon: <ShapeStarFilledIcon fontSize="inherit" />,
    emptyIcon: <ShapeStarIcon fontSize="inherit" />,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-disabled': {
        opacity: '1',
        '& .MuiRating-icon': {
          '&.MuiRating-iconFilled, &.MuiRating-iconEmpty': {
            color: theme.palette.disabled.tertiary,
          },
        },
      },
      // focus visible state
      '&.Mui-focusVisible .MuiRating-iconActive, & .MuiRating-labelEmptyValueActive': {
        outline: 'none',
        boxShadow: getFocusRingBoxShadow(theme),
      },
      // size overrides
      '&.MuiRating-sizeSmall, &.MuiRating-sizeMedium': {
        // match figma 24px height
        padding: '2px 0',
        gap: '12px',
        '& .MuiRating-iconFilled, & .MuiRating-iconEmpty': {
          fontSize: '20px',
        },
      },
      '&.MuiRating-sizeLarge': {
        // match figma 40px height
        padding: '3px 0',
        gap: '22px',
        '& .MuiRating-iconFilled, & .MuiRating-iconEmpty': {
          fontSize: '34px',
        },
      },
      '& .MuiRating-icon': {
        borderRadius: '2px',
        transition: 'none',
        transform: 'none',
        // hover effects
        '&.MuiRating-iconHover': {
          color: theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brand.primary,
        },
        '&.MuiRating-iconFilled': {
          // color: theme.palette.brand.primary,
          color: theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brand.primary,
        },
        '&.MuiRating-iconEmpty': {
          color: theme.palette.mode === 'dark' ? theme.palette.onSurface.os300 : theme.palette.onSurface.os600,
        },
      },
      '& .MuiRating-decimal': {
        transform: 'none',
        // will overwrite maxWidth: '100%' from css reset
        '& *': {
          maxWidth: 'none',
        },
      },
      '& .MuiRating-label': {
        borderRadius: '2px',
      },
    }),
  },
};
